import type { OccI18N } from '@vista-digital/occ-ui'

export const getFormattedSiteCount = (
    template: string,
    siteCount: number,
    maximumSelectedSites: number,
    i18n: OccI18N
): string => {
    return i18n.template(template, { siteCount, maximumSelectedSites })
}
